"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrazeActions = void 0;
const core_1 = require("../../core");
const FoxApi_1 = require("../../core/FoxApi");
class BrazeActions {
    constructor({ apiKey, apiUrl }) {
        this.foxApi = new FoxApi_1.FoxApi({ baseURL: apiUrl, apiKey });
    }
    applyCoupon(couponCode) {
        core_1.AuthStore.configure();
        return this.foxApi.applyCoupon(couponCode).catch((error) => {
            (0, core_1.logError)(error);
            throw error;
        });
    }
    updateSubscription(params) {
        core_1.AuthStore.configure();
        return this.foxApi
            .getPaymentMethods()
            .then((res) => {
            if (res) {
                const { hasPaymentMethods, methods } = res;
                if (hasPaymentMethods) {
                    const [method] = methods;
                    const { paymentmethodInfo } = method;
                    const changeParams = Object.assign(Object.assign({}, params), { paymentmethodInfo });
                    return this.foxApi.changeService(changeParams);
                }
                return Promise.reject(Error("No Payment Methods found on profile"));
            }
            (0, core_1.logError)(res);
            throw res;
        });
    }
}
exports.BrazeActions = BrazeActions;
//# sourceMappingURL=Actions.js.map